import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';

function StatCard({label, value, color = 'text-gray-900'}) {
  return (
    <div className="bg-white rounded-lg shadow p-5">
      <p className="text-sm text-gray-500 mb-1">{label}</p>
      <p className={`text-2xl font-bold ${color}`}>{value}</p>
    </div>
  );
}

export default function Reports() {
  const [report, setReport] = useState(null);

  useEffect(() => {
    api('/hcm/reports').then(r => r.json()).then(setReport).catch(() => {});
  }, []);

  if (!report) return <Layout><div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" /></div></Layout>;

  return (
    <Layout>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Reports</h1>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <StatCard label="Total Employees" value={report.totalEmployees} />
        <StatCard label="Active" value={report.activeEmployees} color="text-green-600" />
        <StatCard label="Terminated" value={report.terminatedEmployees} color="text-red-600" />
        <StatCard label="Recent Hires (90d)" value={report.recentHires} color="text-indigo-600" />
        <StatCard label="Recent Terminations (90d)" value={report.recentTerminations} color="text-orange-600" />
        <StatCard label="Pending PTO Requests" value={report.pendingPtoRequests} color="text-yellow-600" />
        <StatCard label="Credentials Expiring Soon" value={report.credentialsExpiringSoon} color="text-amber-600" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {report.byDepartment && report.byDepartment.length > 0 && (
          <div className="bg-white rounded-lg shadow p-5">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">By Department</h2>
            <div className="space-y-3">
              {report.byDepartment.map(d => (
                <div key={d.label} className="flex items-center justify-between">
                  <span className="text-gray-700">{d.label}</span>
                  <div className="flex items-center gap-3">
                    <div className="w-32 bg-gray-200 rounded-full h-2">
                      <div className="bg-indigo-600 h-2 rounded-full" style={{width: `${Math.min(100, (d.count / report.totalEmployees) * 100)}%`}} />
                    </div>
                    <span className="text-sm font-medium text-gray-900 w-8 text-right">{d.count}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {report.byEmploymentType && report.byEmploymentType.length > 0 && (
          <div className="bg-white rounded-lg shadow p-5">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">By Employment Type</h2>
            <div className="space-y-3">
              {report.byEmploymentType.map(d => (
                <div key={d.label} className="flex items-center justify-between">
                  <span className="text-gray-700">{d.label}</span>
                  <div className="flex items-center gap-3">
                    <div className="w-32 bg-gray-200 rounded-full h-2">
                      <div className="bg-green-600 h-2 rounded-full" style={{width: `${Math.min(100, (d.count / report.totalEmployees) * 100)}%`}} />
                    </div>
                    <span className="text-sm font-medium text-gray-900 w-8 text-right">{d.count}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
